import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { NCCard, NCCard2SectionLayout, NCCardAnalysisTypeToggle, NCCardHeader } from '@/components/NCCard/NCCard';
import { RestorationWaterExplainer } from '@/components/NCExplainers/RestorationWaterExplainer';
import { useScreenSize } from '@/hooks/useScreenSize';

import { WaterCardGraphTile } from './GraphTile';
import { WaterCardStatsTile } from './StatsTile';

export const WaterCard = () => {
  const { t } = useTranslation();
  const isSmallScreen = useScreenSize() === 'small';

  return (
    <NCCard explainer={<RestorationWaterExplainer />}>
      <NCCardHeader title={t('shared.ncaDetail.details.water.labels.waterHoldingCapacity')}>
        {!isSmallScreen && <NCCardAnalysisTypeToggle />}
      </NCCardHeader>
      <NCCard2SectionLayout>
        <Stack className='items-center pt-4 sm:items-stretch sm:pt-0'>
          {isSmallScreen && <NCCardAnalysisTypeToggle />}
          <WaterCardGraphTile />
        </Stack>
        <WaterCardStatsTile />
      </NCCard2SectionLayout>
    </NCCard>
  );
};
